import React from 'react'
import { DepartmentModel } from '../../../models/DepartmentModel';
import { EmpModel } from '../../../models/EmpModel';

interface Props {
  aEmp: EmpModel;
  depts: DepartmentModel[];
  onEditEmp: (badgeNo: string) => void;
}

const CardEmp = ({aEmp, depts, onEditEmp}: Props) => {
  
  const dept = depts.find( dept => dept.deptCode === aEmp.department);

  return (
    // <div className="relative w-fit mx-auto bg-white shadow-lg rounded-xl p-6 border border-gray-100">
    <div className="relative w-[300px] max-w-full bg-white shadow-lg rounded-xl p-6 border border-gray-100">
      <div className='flex justify-end mb-2'>
        <button
          onClick={() => {
            onEditEmp(aEmp.badgeNo)}
          }
          className='text-sm bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded-lg'
          > Edit 
        </button>
      </div>
      <div className="flex gap-2 items-baseline gap-x-1 font-semibold text-gray-800 mb-4">
        <span className="text-sm font-semibol"> 
          Badge No.:
        </span>  
        <span className='text-sm'>
          {aEmp.badgeNo}
        </span>
      </div>
      
      <div className="flex gap-2 items-baseline gap-x-1 text-black">
          <span className="text-sm font-semibold">Name:</span> 
          <span className='text-sm'> {aEmp.firstName + " " + aEmp.lastName }</span>
      </div>
      {aEmp.isSupervisor && <div className="text-sm font-semibold text-green-600">Supervisor</div>}
      {aEmp.isStocker && <div className="text-sm font-semibold text-blue-600">Stocker</div>}
      <div className="flex gap-2 items-baseline gap-x-1 text-black">
          <span className="text-sm font-semibold">Dept. Code:</span> 
          <span className='text-sm'> {dept ? dept.deptCode : "Not Assigned" }</span>
      </div>
      <div className="flex gap-2 items-baseline gap-x-1 text-black">
          <span className="text-sm font-semibold">Dept.Name:</span> 
          <span className='text-sm'> {dept ? dept.description : "" }</span>
      </div>
    </div>  
  )
}

export default CardEmp